export const defaultColumns = [
  {label: 'Nome', value: 'display_name'},
  {label: 'Descrição', value: 'description'},
  {label: 'Regiões', value: 'region'},
  {label: 'Data', value: 'date'},
  {label: 'Ações', value: 'actions', className: 'w-9'},
]
